import { UseCase } from '@core/referential/use-case.enum'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

import PendingComponent from '@/components/pending-component'
import { isUseCase } from '@/lib/utils'

import { SearchSchema } from '../-utils/search'

const airQualitySearchSchema = z.object({
  chartHistory: z.union([z.literal('co2'), z.literal('humidity'), z.literal('tvoc')]).optional(),
  deviceHistory: z.string().optional(),
})

export type AirQualitySearch = z.infer<typeof airQualitySearchSchema>

export const Route = createFileRoute('/_dashboard/air-quality/history/')({
  validateSearch: SearchSchema.merge(airQualitySearchSchema),
  async beforeLoad() {
    if (!isUseCase(UseCase.AIR_QUALITY)) {
      throw redirect({
        to: '/403',
        search: { reason: 'wrongUseCase' },
      })
    }
  },
  pendingComponent: PendingComponent,
})
